import { observer } from 'mobx-react';
import { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import WHLogStore from 'src/view/screens/WorkingHoursLogScreen/screens/WorkingHoursLog/store/WorkingHoursLogStore';
import { reportsStore } from '~/view/screens/ReportsScreen/store/reportsStore';
import ReportsCalendar from '~/view/screens/ReportsScreen/components/ReportsCalendar/ReportsCalendar';
import { getTranslate } from '~/utils/helpers';
import { allOptionsValue } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import { BranchProfilePicker } from '~/view/components/Controls/Pickers/BranchProfilePicker/BranchProfilePicker';
import { branchesWorkingHoursStore } from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/store/branchesWorkingHoursStore';
import { ordersRatingStore } from '~/view/screens/OrdersRatingScreen/store/ordersRatingStore';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';

const WHLogHeader = (): JSX.Element => {
  const { id } = useParams<{ id?: string }>();

  const getId = (): number | null => {
    if (id && Number(id) > 0) {
      return Number(id);
    }

    return null;
  };

  const allProfilesOption = (): IPickerOption => {
    return { label: localeStore.t('wh_log_all_profiles_selected'), value: allOptionsValue };
  };

  useEffect(() => {
    const fetchAllProfiles = async () => {
      await branchesWorkingHoursStore.getAllProfiles();
    };

    const profileId = getId();

    if (profileId) {
      WHLogStore.setFilters({ profileIds: [profileId] });
    }

    fetchAllProfiles();
  }, []);

  // For "Date" Filter
  const onSelectDate = () => {
    WHLogStore.setFilters({ startDate: reportsStore.filters.startDate, endDate: reportsStore.filters.endDate });
  };

  // For "Branch" Filter
  const getOptions = (): IPickerOption[] => {
    return [
      allProfilesOption(),
      ...branchesWorkingHoursStore.AllProfilesList.map((branch) => ({
        label: getTranslate(branch.name),
        value: branch.id,
        warringText: branch.is_delete === 1 ? localeStore.t('wh_whp_was_deleted') : undefined,
      })),
    ];
  };

  const getDefaultOptions = (): IPickerOption[] => {
    return [allProfilesOption()];
  };

  const selectedOptions = (): IPickerOption[] => {
    const profileId = getId();

    const profiles = branchesWorkingHoursStore.AllProfilesList.filter(
      (profile) => profile.id === profileId || WHLogStore.filters.profileIds?.includes(profile.id)
    );

    return profiles.map((profile) => ({ label: getTranslate(profile.name), value: profile.id }));
  };

  const onSelectProfile = (options: IPickerOption[]) => {
    const ids = options.map((option) => option.value);
    const profileIds = ids.includes(allOptionsValue) ? undefined : ids;

    WHLogStore.setFilters({ profileIds });
  };

  return (
    <div className="d-flex flex-row justify-content-between pr-4">
      <div className="d-flex flex-row">
        <ReportsCalendar startDate={reportsStore.filters.startDate} endDate={reportsStore.filters.endDate} onSelectDate={onSelectDate} />
        <Picker
          placeholder={localeStore.t('wh_log_all_profiles_selected')}
          selectedItemsPlaceholder="selected_whp"
          key="branches-picker"
          options={getOptions()}
          selectedOptions={selectedOptions()}
          onSelect={onSelectProfile}
          hideResetIcon
          isMulti
          searchable
          className="orders-rating-header__branches-picker mr-2"
        />
      </div>
    </div>
  );
};

export default observer(WHLogHeader);
